// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/routes/event-drupalcon.request.tsx"
);
import.meta.hot.lastModified = "1773385375631.9497";
}
// REMIX HMR END

import { ActionFunctionArgs } from "@remix-run/cloudflare";
import { makeDomainFunction } from "domain-functions";
import { z } from "zod";
import { formAction } from "~/components/forms/form-action.server";
import { sendEventDrupalcon2025Request } from "~/services/mailchimp.server";
import { checkHoneypot } from "~/utils/honeypot.server";

export const schema = z.object({
  campaign: z.string().min(1, { message: "This field is required." }),
  name: z.string().min(1, { message: "This field is required." }),
  lastName: z.string().optional(),
  email: z.string().min(1, { message: "This field is required." }).email({
    message: "Write a valid email.",
  }),
  company: z.string().min(1, { message: "This field is required." }),
  role: z
    .enum([
      "Select an option",
      "C-Level",
      "Director or Lead",
      "Developer",
      "Marketing",
      "Other",
    ])
    .default("Select an option")
    .refine((value) => value !== "Select an option", {
      message: "Please select an option.",
    }),
});

const environmentSchema = z.object({
  MAILCHIMP_API_KEY: z.string(),
  MAILCHIMP_SERVER_PREFIX: z.string(),
  MAILCHIMP_LIST_ID: z.string(),
});

const mutation = makeDomainFunction(
  schema,
  environmentSchema
)(async ({ campaign, email, name, lastName, company, role }, context) => {
  await sendEventDrupalcon2025Request(
    {
      campaign,
      email,
      name,
      lastName,
      company,
      role,
    },
    context as any
  );

  return {
    success: true,
  };
});

export const action = async ({
  request,
  context: environment,
}: ActionFunctionArgs) => {
  const formData = await request.clone().formData();
  await checkHoneypot(formData, environment.HONEYPOT_SEED as string);
  console.log("formData", formData);
  return await formAction({
    request,
    schema,
    mutation,
    environment,
  });
};
